export const stepOneData = [
  {
    heading: "Why Use the ICICI Bank Car Loan EMI Calculator?",
    // paras before heading

    impactHead: "Impact of Loan Tenure on EMI and Total Repayment",

    infoList: [
      {
        heading: "Accurate Calculations: ",
        description:
          "Get precise EMI amounts for your car loan, breaking down how the EMI is divided between the principal and interest.",
      },
      {
        heading: "Convenience: ",
        description:
          "The calculator is available online for free, anytime and anywhere, to help you plan your car loan payments at your convenience.",
      },
      {
        heading: "Detailed Breakdown: ",
        description:
          "View a comprehensive breakdown of your EMI, showing exactly how much goes towards the principal and how much is paid as interest.",
      },
      {
        heading: "Real-Time Results: ",
        description:
          "Get instant results to make quicker, more confident financial decisions.",
      },
    ],
    tip: "Use Prepayment to Save Interest: If possible, make partial prepayments to reduce the principal, which will decrease your interest burden over time.",
  },
];

export const stepTwoData = [
  {
    heading: "Features of ICICI Bank Car Loans",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate (Starting)",
        },
        {
          head: "Maximum Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Car Loan",
          interest: "8.75% p.a.",
          tenure: "Up to 7 years",
          fee: "0.5% - 1.5% of loan amount",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Benefits of Using the ICICI Car Loan EMI Calculator",

    factorsList: [
      {
        heading: "Efficient Planning: ",
        info: "Use the calculator to better understand your loan commitment and plan your finances accordingly.",
      },
      {
        heading: "Easy Comparison: ",
        info: "Quickly compare different loan types, amounts, and tenures to find the best option for you.",
      },
      {
        heading: "Cost Transparency: ",
        info: "See the total cost of your car loan, including the total interest payable.",
      },
      {
        heading: "No Cost Tool: ",
        info: "The calculator is available online for free, helping you avoid any unnecessary charges.",
      },
    ],
    tip: "Maintain a Good Credit Score: A higher credit score ensures access to better rates and more favorable loan terms.",
  },
];

export const stepFourData = [
  {
    heading: "Factors Influencing Your Car Loan EMI and Total Repayment",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "A higher loan amount results in higher monthly EMIs.",
      },
      {
        heading: "Interest Rate: ",
        info: "The interest rate directly affects the EMI; higher rates lead to higher EMIs and more interest paid over the loan term.",
      },
      {
        heading: "Loan Tenure: ",
        info: "Opting for a longer tenure reduces the EMI but increases the total interest paid over time.",
      },
      {
        heading: "Processing Fees: ",
        info: "Always account for the processing fees, as they will be added to the total loan cost.",
      },
      {
        heading: "Prepayment and Foreclosure: ",
        info: "Making prepayments or foreclosing the loan reduces the principal, which in turn lowers your EMI and loan tenure.",
      },
    ],
  },
];
export const stepFiveData = [
  {
    heading: "How to Use the ICICI Car Loan EMI Calculator",
    tip: "Compare Offers: Don’t just settle for one lender; compare interest rates, processing fees, and other charges to find the best car loan deal.",
  },
];
export const stepSixData = [
  {
    heading: "Impact of Loan Tenure on EMI and Total Repayment",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Total Interest Paid",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "5 years",
          emi: "Higher	",
          interest: "Lower",
          repayment: "Lower",
        },
        {
          tenure: "7 years	",
          emi: "Moderate",
          interest: "Moderate",
          repayment: "Moderate",
        },
        {
          tenure: "10 years",
          emi: "Lower	",
          interest: "Higher",
          repayment: "Higher",
        },
      ],
    },
    tip: "Negotiate Better Rates: A good credit score (750+) may help you qualify for lower interest rates.",
  },
];
